import React from 'react';
import { Redirect } from 'react-router-dom';

export const Admin = ({ location: { pathname } }) => (
  <Redirect
    to={`${pathname}/users`}
  />
);

export default Admin;



// WEBPACK FOOTER //
// ./src/components/Admin/index.js